import { useRef, useState, useEffect, useMemo } from 'react';
import { makeBirthDate, makeFormErrors, makePhone, slashesToDashes } from '../utils';
const allFields = [
    { label: 'First Name', name: 'first_name', type: 'text', required: true },
    { label: 'Last Name', name: 'last_name', type: 'text', required: true },
    {
        label: 'Email',
        name: 'email',
        type: 'email',
        required: true,
        autoComplete: 'email'
    },
    { label: 'Phone', name: 'phone', type: 'tel', required: true },
    { label: 'Company', name: 'company', type: 'text' },
    { label: 'Birth Date (mm/dd/yyyy)', name: 'birth_date', type: 'tel' }
];
const makePayload = (fields, data) => {
    if (!data)
        return null;
    const rest = fields.reduce((obj, i) => (Object.assign(Object.assign({}, obj), { [i.name]: data[i.name] })), {});
    rest.birth_date = data.birth_date ? slashesToDashes(data.birth_date) : null;
    return rest;
};
export const useProfileForm = (profile, loading, error, update, callback, optionalFields) => {
    const submitRef = useRef(null);
    const [data, setData] = useState(profile);
    const [submitting, setSubmitting] = useState(false);
    const [errors, setErrors] = useState({});
    const toRemove = useMemo(() => {
        const removed = [];
        if (optionalFields && !optionalFields.includes('birth_date'))
            removed.push('birth_date');
        return removed;
    }, [optionalFields]);
    // const fields = allFields.filter((i) => !toRemove.includes(i.name))
    const fields = useMemo(() => {
        return allFields.filter(i => !toRemove.includes(i.name));
    }, [toRemove]);
    useEffect(() => {
        if (loading === 'idle') {
            setSubmitting(false);
            if (error) {
                const errs = makeFormErrors(error);
                if (errs.birth_date) {
                    errs.birth_date =
                        'Invalid date. Please enter in mm/dd/yyyy format or leave blank.';
                }
                setErrors(errs);
            }
            else if (callback && submitting) {
                const payload = makePayload(fields, data);
                if (payload)
                    callback(payload);
            }
        }
    }, [loading, error, callback, submitting, fields, data]);
    useEffect(() => {
        if (profile)
            setData(profile);
    }, [profile]);
    const handleChange = (name, value) => {
        const inputValue = name === 'phone'
            ? makePhone((value !== null && value !== void 0 ? value : ''))
            : name === 'birth_date'
                ? makeBirthDate(value)
                : value;
        if (data)
            setData(Object.assign(Object.assign({}, data), { [name]: inputValue }));
    };
    // const handleRadio = (name: string, value: string) => {
    //   if (data) setData({ ...data, [name]: value })
    // }
    const handleSubmit = (evt) => {
        var _a, _b;
        evt === null || evt === void 0 ? void 0 : evt.preventDefault();
        if (!data)
            return;
        setErrors({});
        setSubmitting(true);
        const payload = makePayload(fields, data);
        if (payload)
            update(payload);
        ((_a = submitRef.current) === null || _a === void 0 ? void 0 : _a.blur) && ((_b = submitRef.current) === null || _b === void 0 ? void 0 : _b.blur());
    };
    return {
        submitRef,
        // accepts_marketing,
        // order_notifications,
        data,
        errors,
        submitting,
        fields,
        handleChange,
        // handleRadio,
        handleSubmit
    };
};
